import React from 'react';

import { useDateTimeContext } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

import { TIMEZONE_LOCAL, TIMEZONE_UTC } from 'ae-constants/constants';

import {
  RadioButtonListDropdownMenuItem,
  type RadioButtonListDropdownMenuItemOption,
} from '../../radio-button-list-menu-item';

export const TimezoneSwitchMenuItem: React.FC = () => {
  const { t } = useTranslation();
  const { timezone, setTimezone } = useDateTimeContext();

  const options: RadioButtonListDropdownMenuItemOption<'local' | 'utc'>[] = [
    { label: t('appBar:settingsMenu.local'), value: TIMEZONE_LOCAL },
    { label: t('appBar:settingsMenu.utc'), value: TIMEZONE_UTC },
  ];

  return (
    <RadioButtonListDropdownMenuItem
      title={t('appBar:settingsMenu.displayTime')}
      defaultValue={timezone}
      onValueChange={setTimezone}
      options={options}
    />
  );
};
